import { useQuery } from "@apollo/client";
import React, { FC } from "react";
import { useParams } from "react-router-dom";
import { Box, CircularProgress } from "@material-ui/core";
import CompanySearch from "./CompanySearch";
import { ONBOARDING } from "../../../graphql/onboarding/onboarding/query";
import { OnboardingInfo } from "../../../graphql/onboarding/onboarding/types/OnboardingInfo";
import { useToastNotifications } from "../../../utils/toastUtils";

const CompanySearchProvider: FC = () => {
  const { incorporationCode } = useParams();
  const { showErrorToast } = useToastNotifications();
  const { data: onboarding, loading } = useQuery<OnboardingInfo>(ONBOARDING, {
    fetchPolicy: "network-only",
    onError: () => {
      showErrorToast({
        description: `onboarding.retrieving.information.error`,
      });
    },
  });

  if (loading) {
    return (
      <Box position="absolute" top="50%" left="50%">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <CompanySearch
      incorporationCode={
        onboarding?.onboardingInfo?.company?.code || incorporationCode || ""
      }
    />
  );
};

export default CompanySearchProvider;
